import { Skeleton } from "@/components/ui/skeleton";

const DisclosureRowsSkeleton = ({ count = 3 }) => (
  <div className="flex flex-col gap-3 pl-2">
    {Array.from({ length: count }).map((_, index) => (
      <div
        key={`target-setup-disclosure-row-skeleton-${index}`}
        className="flex items-center gap-3 rounded-lg border border-border bg-card px-4 py-3"
      >
        <Skeleton className="h-10 w-10 rounded-lg" />
        <div className="flex-1 space-y-1.5">
          <div className="flex items-center gap-2">
            <Skeleton className="h-4 w-14 rounded" />
            <Skeleton className="h-4 w-40" />
          </div>
          <div className="flex items-center gap-3">
            <Skeleton className="h-3 w-12" />
            <Skeleton className="h-3 w-10" />
            <Skeleton className="h-3 w-24" />
          </div>
        </div>
        <Skeleton className="h-8 w-28 rounded" />
      </div>
    ))}
  </div>
);

export default DisclosureRowsSkeleton;
